import * as React from 'react';
import SuperCritical from 'lib/supercritical';

import { PortCallLog } from './model';

import { NewCommentView } from 'portcall/eventlog/newcommentview';
import { EventLogView } from 'portcall/eventlog/view';

export const PortCallLogView = SuperCritical(({model} : { model : PortCallLog }) =>
    <div className="portcalllog">
        <div className="pc-card log-post-section">
            <div className="pc-card-header">
                <span className="pc-card-title">Log</span>
            </div>
            <div className="log-description">
                <span className="pc-text-tinylabel">
                    Record and track this PortCall's history and events.
                </span>
            </div>
            <NewCommentView model={model.NewComment} topLevel />
        </div>
        <EventLogView model={model.EventLog} />
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/portcalllog/view.tsx